<template>
  <div>
    <div class="atm-desktop-max-width mobile">
      <div>
        <p class="text-muted m-0 w-100">
          Manage the coins the student will earn.
        </p>
        <b-skeleton
          type="Button"
          class="bg-main mr-2 text-light text-right rounded-pill py-1 ml-auto small"
          width="160px"
        >
        </b-skeleton>
      </div>
      <hr class="my-4 w-100" />
      <b-form class="d-flex gap-4 flex-column w-100">
        <div
          v-for="(coinstValue, index) in coinsValues"
          :key="index"
          class="d-flex gap-3 mb-3 flex-wrap w-100"
        >
          <b-skeleton class="m-0" v-if="coinstValue.module" width="100px"> </b-skeleton>
          <div
            v-for="coinstItem in coinstValue.items"
            :key="coinstItem.id"
            class="d-flex gap-4 justify-content-between align-items-center w-100 flex-wrap"
          >
            <b-skeleton class="text-secondary m-0" width="200px"></b-skeleton>
            <div class="coins-update d-flex gap-2 align-items-center atm-shadow py-0">
              <div class="coin-container">
                <img class="coins-image" :src="require(`@/assets/coin.png`)" />
              </div>
              <b-skeleton type="input" />
            </div>
          </div>
        </div>
        <b-skeleton type="Button" class="atm-button bg-main mx-auto my-4" width="45%"> </b-skeleton>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coinsValues: [
        {
          items: [0, 1],
        },
        {
          module: true,
          items: [0, 1, 2],
        },
        {
          module: true,
          items: [0, 1, 2, 3, 4],
        },
      ],
    };
  },
};
</script>

<style></style>

